import { Button } from "@material-ui/core";
import moment from "moment";
import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export function Download(props) {

  return (
    <ExcelFile element={props.button} filename={props.filename}>
      {props.status.includes("processingredemption")?
      <ExcelSheet data={props.data} name="Redemption">
        <ExcelColumn label="User Account's Number" value="accountNumber" />
        <ExcelColumn label="Official Account Name" value="clientName" />
        <ExcelColumn label="Client Name" value="clientName" />
        <ExcelColumn label="Company Name" value="companyName" />
        <ExcelColumn label="Fund Name" value="fundName" />
        <ExcelColumn label="Fund Code" value="fundCode" />
        <ExcelColumn label="Total Amount" value="amountFormat" />
        <ExcelColumn label="Investment Amount" value="invAmountFormat" />
        <ExcelColumn label="Submission Date" value="subDate" />
        <ExcelColumn label="Submission Time" value="subTime" />
        <ExcelColumn label="Transaction ID" value="transId" />
        <ExcelColumn label="Date Processed" value="" />
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Folio Number" value="folio" />
        <ExcelColumn
          label="Shares"
          value={
            (value) => 
            value.status === "processingRedemption"
              ? value.shares
              : ""
          }
        />
        <ExcelColumn
          label="NAVPS Booking Time"
          value={(value) =>
            value.status === "processingRedemption" ? value.rateAtBooking : ""
          }
        />
        <ExcelColumn label="Fee" value="fee" />
        <ExcelColumn
          label="Bank Account Number"
          value={(value) =>
            value?.settlementDetails?.bankAccountNumber !== undefined
              ? value?.settlementDetails?.bankAccountNumber
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Name"
          value={(value) =>
            value?.settlementDetails?.accountName !== undefined
              ? value?.settlementDetails?.accountName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Name"
          value={(value) =>
            value?.settlementDetails?.bankName !== undefined
              ? value?.settlementDetails?.bankName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Type"
          value={(value) =>
            value?.settlementDetails?.savingsAccount !== undefined
              ? value?.settlementDetails?.savingsAccount
                ? "Savings"
                : "Current"
              : "n/a"
          }
        />
        <ExcelColumn label="Transaction Image" value="transactionImage" />
         <ExcelColumn label="Market Value" /> 
         <ExcelColumn label="Exit Fee" /> 
         <ExcelColumn label="Less: Service Fee" /> 
         <ExcelColumn label="Net Pay" /> 
        <ExcelColumn label="Payment Validation" value="paymentValid" />
      </ExcelSheet>:
      <ExcelSheet data={props.data} name="Investments">
        <ExcelColumn label="User Account's Number" value="accountNumber" />
        <ExcelColumn label="Official Account Name" value="clientName" />
        <ExcelColumn label="Client Name" value="clientName" />
        <ExcelColumn label="Company Name" value="companyName" />
        <ExcelColumn label="Fund Name" value="fundName" />
        <ExcelColumn label="Fund Code" value="fundCode" />
        <ExcelColumn label="Total Amount" value="amountFormat" />
        <ExcelColumn label="Investment Amount" value="invAmountFormat" />
        <ExcelColumn label="Submission Date" value="subDate" />
        <ExcelColumn label="Submission Time" value="subTime" />
        <ExcelColumn label="Transaction ID" value="transId" />
        <ExcelColumn label="Date Processed" value="" />
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Folio Number" value="folio" />
        <ExcelColumn
          label="Shares"
          value={
            (value) => 
            value.status === "processingRedemption"
              ? value.shares
              : ""
          }
        />
        <ExcelColumn
          label="NAVPS Booking Time"
          value={(value) =>
            value.status === "processingRedemption" ? value.rateAtBooking : ""
          }
        />
        <ExcelColumn label="Fee" value="fee" />
        <ExcelColumn
          label="Bank Account Number"
          value={(value) =>
            value?.settlementDetails?.bankAccountNumber !== undefined
              ? value?.settlementDetails?.bankAccountNumber
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Name"
          value={(value) =>
            value?.settlementDetails?.accountName !== undefined
              ? value?.settlementDetails?.accountName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Name"
          value={(value) =>
            value?.settlementDetails?.bankName !== undefined
              ? value?.settlementDetails?.bankName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Type"
          value={(value) =>
            value?.settlementDetails?.savingsAccount !== undefined
              ? value?.settlementDetails?.savingsAccount
                ? "Savings"
                : "Current"
              : "n/a"
          }
        />
        <ExcelColumn label="Transaction Image" value="transactionImage" />
        <ExcelColumn label="Payment Validation" value="paymentValid" />
      </ExcelSheet>}
      
    </ExcelFile>
  );
}
export function DownloadBPI(props) {

  return (
    <ExcelFile element={props.button} filename={props.filename}>

      <ExcelSheet  data={props.data} name="Export New BPI UITF Investors">
        <ExcelColumn label="RFO ID Number" value="accountNumber" />
        <ExcelColumn label="Surname"  
        value={(value) =>
            value?.kyc?.name?.lastName !== undefined
              ? value?.kyc?.name?.lastName
              : "n/a"
          } 
          />
        <ExcelColumn label="First Name" 
         value={(value) =>
            value?.kyc?.name?.firstName !== undefined
              ? value?.kyc?.name?.firstName
              : "n/a"
          }
        />
        <ExcelColumn label="Middle Name" 
        value={(value) =>
            value?.kyc?.name?.middleName !== undefined
              ? value?.kyc?.name?.middleName
              : "n/a"
          } 
          />
        <ExcelColumn label="Current Address" value={(value) =>
            value?.kyc?.currentAddress?.street !== undefined
              ? `${value?.kyc?.currentAddress?.street}(${value?.kyc?.currentAddress?.zip})` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address City" value={(value) =>
            value?.kyc?.currentAddress?.city !== undefined
              ? ` ${value?.kyc?.currentAddress?.city}` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address Province" value={(value) =>
            value?.kyc?.currentAddress?.province !== undefined
              ? ` ${value?.kyc?.currentAddress?.province}` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address Country" value={(value) =>
            value?.kyc?.currentAddress?.country !== undefined
              ? ` ${value?.kyc?.currentAddress?.country}` 
              : "n/a"
          }/>
       

        <ExcelColumn label="Email Address" 
        value={(value) => value?.kyc?.email
          } />
        <ExcelColumn label="Date of Birth" value={""} />
        <ExcelColumn label="Mobile Phone Number" value={(value) => value?.kyc?.mobileNumber} />
        <ExcelColumn label="Citizenship" value={(value) => value?.kyc?.nationality} />
        <ExcelColumn label="Source of Fund" value={(value) =>
            value?.kyc?.work?.sourceOfFunds !== undefined
              ?  value?.kyc?.work?.sourceOfFunds
              : "n/a"
          } />
           <ExcelColumn label="TIN Number" value={(value) =>
            value?.kyc?.ids?.TIN !== undefined
              ? `` 
              : "n/a"
          }/>
        <ExcelColumn label="Name of Business or Employer's Business"value={(value) =>
            value?.kyc?.work?.nameOfEmployer !== undefined
              ?  value?.kyc?.work?.nameOfEmployer
              : "n/a"
          } />
          
        <ExcelColumn label="Nature of Business or Employer's Business"value={(value) =>
            value?.kyc?.work?.businessNature !== undefined
              ?  value?.kyc?.work?.businessNature
              : "n/a"
          } />
        <ExcelColumn label="Gender / Sex" value={(value) => value?.kyc?.gender} />
        <ExcelColumn label="Suitability Risk Profile Result" value="riskProfile" />
        <ExcelColumn label="AML Risk Profile " value="" />
      </ExcelSheet>
      
    </ExcelFile>
  );
}
export function DownloadATRAM(props) {

  return (
    <ExcelFile element={props.button} filename={props.filename}>

      <ExcelSheet  data={props.data} name="Export New ATRAM UITF Investors">
        <ExcelColumn label="RFO ID Number" value="accountNumber" />
        <ExcelColumn label="Surname"  
        value={(value) =>
            value?.kyc?.name?.lastName !== undefined
              ? value?.kyc?.name?.lastName
              : "n/a"
          } 
          />
        <ExcelColumn label="First Name" 
         value={(value) =>
            value?.kyc?.name?.firstName !== undefined
              ? value?.kyc?.name?.firstName
              : "n/a"
          }
        />
        <ExcelColumn label="Middle Name" 
        value={(value) =>
            value?.kyc?.name?.middleName !== undefined
              ? value?.kyc?.name?.middleName
              : "n/a"
          } 
          />
        <ExcelColumn label="Current Address" value={(value) =>
            value?.kyc?.currentAddress?.street !== undefined
              ? `${value?.kyc?.currentAddress?.street}(${value?.kyc?.currentAddress?.zip})` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address City" value={(value) =>
            value?.kyc?.currentAddress?.city !== undefined
              ? ` ${value?.kyc?.currentAddress?.city}` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address Province" value={(value) =>
            value?.kyc?.currentAddress?.province !== undefined
              ? ` ${value?.kyc?.currentAddress?.province}` 
              : "n/a"
          }/>
        <ExcelColumn label="Current Address Country" value={(value) =>
            value?.kyc?.currentAddress?.country !== undefined
              ? ` ${value?.kyc?.currentAddress?.country}` 
              : "n/a"
          }/>
       

        <ExcelColumn label="Email Address" 
        value={(value) => value?.kyc?.email
          } />
        <ExcelColumn label="Date of Birth" value={(value) => value?.kyc?.dateOfBirth} />
        <ExcelColumn label="Mobile Phone Number" value={(value) => value?.kyc?.mobileNumber} />
        <ExcelColumn label="Citizenship" value={(value) => value?.kyc?.nationality} />
        <ExcelColumn label="Source of Fund" value={(value) =>
            value?.kyc?.work?.sourceOfFunds !== undefined
              ?  value?.kyc?.work?.sourceOfFunds
              : "n/a"
          } />
           <ExcelColumn label="TIN Number" value={(value) =>
            value?.kyc?.ids?.TIN !== undefined
              ? ` ${value?.kyc?.ids?.TIN}` 
              : "n/a"
          }/>
        <ExcelColumn label="Name of Business or Employer's Business"value={(value) =>
            value?.kyc?.work?.nameOfEmployer !== undefined
              ?  value?.kyc?.work?.nameOfEmployer
              : "n/a"
          } />
          
        <ExcelColumn label="Nature of Business or Employer's Business"value={(value) =>
            value?.kyc?.work?.businessNature !== undefined
              ?  value?.kyc?.work?.businessNature
              : "n/a"
          } />
        <ExcelColumn label="Gender / Sex" value={(value) => value?.kyc?.gender} />
        <ExcelColumn label="Suitability Risk Profile Result" value="riskProfile" />
        <ExcelColumn label="AML Risk Profile " value="" />
      </ExcelSheet>
      
    </ExcelFile>
  );
}

export function ExportClientData(props) {
  return (
    <ExcelFile element={props.button} filename={props.filename}>
      <ExcelSheet data={props.data} name={"Export Client"}>
        <ExcelColumn label="Submission Date" value="submissionDate" />
        <ExcelColumn label="Creation Date" value="creationDate" />
        <ExcelColumn label="Account Number" value="accountNumber" />
        <ExcelColumn label="Last Name" value="lastName" />
        <ExcelColumn label="First Name" value="firstName" />
        <ExcelColumn label="Email" value="email" />
        <ExcelColumn label="Portfolio Value" value="portfolioValue" />
        <ExcelColumn label="Client Status " value="adminStatus" />
        <ExcelColumn label="Referrer" value="referrer" />
        <ExcelColumn label="User Tier" value="tier" />
      </ExcelSheet>
    </ExcelFile>
  );
}
export function ExportApprovalRecurringData(props) {
  return (
    <ExcelFile element={props.button} filename={props.filename}>
      <ExcelSheet data={props.data} name={"Export Client"}>
        <ExcelColumn label="Registration Date" value="registrationDate" />
        <ExcelColumn label="User Name" value="userName" />
        <ExcelColumn label="User Account's Number" value="userAccount" />
        <ExcelColumn label="Email Address" value="userEmail" />
        <ExcelColumn label="Fund Name" value="fundName" />
        <ExcelColumn label="Fund Code" value="fundCode" />
        <ExcelColumn label="Amount" value="amount" />
        <ExcelColumn label="Account Name" value="accountName" />
        <ExcelColumn label="Name of Bank" value="bankName" />
        <ExcelColumn label="Bank Account Number" value="bankNumber" />
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Day of Month" value="dayofMonth" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export function ExportTransactionData(props) {
  const formattedData = props.data.map((item) => ({
    ...item,
    processedDate: item.processedDate
      ? moment.unix(item.processedDate.seconds).format("MM/DD/YYYY")
      : "",
  }));
  
  return (
    <ExcelFile element={props.button} filename={props.filename}>
      <ExcelSheet data={formattedData} name={"Transaction Data"}>
        <ExcelColumn label="User Account's Number" value="accountNumber" />
        <ExcelColumn label="Official Account Name" value="clientName" />
        <ExcelColumn label="Client Name" value="clientName" />
        <ExcelColumn label="Company Name" value="companyName" />
        <ExcelColumn label="Fund Name" value="fundName" />
        <ExcelColumn label="Fund Code" value="fundCode" />
        <ExcelColumn label="Total Amount" value="amountFormat" />
        <ExcelColumn label="Investment Amount" value="invAmountFormat" />
        <ExcelColumn label="Submission Date" value="subDate" />
        <ExcelColumn label="Submission Time" value="subTime" />
        <ExcelColumn label="Transaction ID" value="transId" />
        <ExcelColumn label="Date Processed" value="processedDate" />
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Folio Number" value="folio" />
        <ExcelColumn label="Shares" value="shares" />
        <ExcelColumn label="NAVPS Booking Time" value="rateAtBooking" />
        <ExcelColumn
          label="Bank Account Number"
          value={(value) =>
            value?.settlementDetails?.bankAccountNumber !== undefined
              ? value?.settlementDetails?.bankAccountNumber
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Name"
          value={(value) =>
            value?.settlementDetails?.accountName !== undefined
              ? value?.settlementDetails?.accountName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Name"
          value={(value) =>
            value?.settlementDetails?.bankName !== undefined
              ? value?.settlementDetails?.bankName
              : "n/a"
          }
        />
        <ExcelColumn
          label="Bank Account Type"
          value={(value) =>
            value?.settlementDetails?.savingsAccount !== undefined
              ? value?.settlementDetails?.savingsAccount
                ? "Savings"
                : "Current"
              : "n/a"
          }
        />
        <ExcelColumn label="Payment Validation" value="paymentValid" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export const DownloadComponents = ({ transactionList, currentTab, firebase }) => {
  const accountNumberIDs = new Set();

  const processingTransactions = transactionList.filter(
    (transaction) => transaction.status === "processing"
  );

  const bpiUITF = transactionList
  .filter((transaction) => transaction.companyName === "BPI Wealth" && transaction.kyc?.hasBPIUITF === undefined && transaction.status === "processing" && transaction?.paymentValid === "validated")
  .filter((transaction) => {
    console.log(transaction)
    if (accountNumberIDs.has(transaction.accountNumber)) return false;
    accountNumberIDs.add(transaction.accountNumber);
    return true;
  });
  const atramUITF = transactionList
  .filter((transaction) => transaction.companyName === "ATRAM Trust Corporation" && transaction.kyc?.hasATCUITF === undefined && transaction.status === "processing" && transaction?.paymentValid === "validated")
  .filter((transaction) => {
    if (accountNumberIDs.has(transaction.accountNumber)) return false;
    accountNumberIDs.add(transaction.accountNumber);
    return true;
  });
   const updatehasBPIUITF = async () => {
      const bpiUITFMap = bpiUITF
  .map(t => t.uid)
const batch = firebase.batch();

for (const uid of bpiUITFMap) {
  
  const kycRef = firebase
    .collection("users")
    .doc(uid)
    .collection("KYC")
    .doc("KYC");

  const docSnap = await kycRef.get();

  if (docSnap.exists) {
    batch.update(kycRef, {
      hasBPIUITF: true
    });
  } else {
    console.log(`KYC document does not exist for UID: ${uid}`);
  }
}

await batch.commit();
console.log("Batch update complete.");
window.location.reload();
  }
   const updatehasATRAMUITF = async () => {
      const atcUITFMap = atramUITF
  .map(t => t.uid)
const batch = firebase.batch();

for (const uid of atcUITFMap) {
  
  const kycRef = firebase
    .collection("users")
    .doc(uid)
    .collection("KYC")
    .doc("KYC");

  const docSnap = await kycRef.get();

  if (docSnap.exists) {
    batch.update(kycRef, {
      hasATCUITF: true
    });
  } else {
    console.log(`KYC document does not exist for UID: ${uid}`);
  }
}

await batch.commit();
console.log("Batch update complete.");
window.location.reload();
  }

  const processingRedemptionTransactions = transactionList.filter(
    (transaction) => transaction.status === "processingRedemption"
  );
  function getEventName(type) {
    const formattedDateTime = moment().format("YYYY-MM-DD--HH-mm-ss");
    const eventNamePrefix = `${formattedDateTime} - `;

    return `${eventNamePrefix}${type}`;
  }

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
      <ExportTransactionData
        data={transactionList}
        filename={`${
          currentTab === "booking" ? "Bookings" : "Redemptions"
        } Transactions List - ${moment().format("MM/DD/YY - hh:mm a")}`}
        button={
          <Button
            variant="contained"
            color="primary"
            fullWidth
            style={{
              color: "white",
              textTransform: "capitalize",
            }}
          >
            {`Export All ${
              currentTab === "booking" ? "Bookings" : "Redemptions"
            }`}
          </Button>
        }
      />
      {currentTab === "booking" ? (
        <>
        <Download
          data={processingTransactions}
          button={
            <Button
              variant="contained"
              color="primary"
              style={{ color: "white", textTransform: "capitalize" }}
              fullWidth
            >
              Generate Processing Excel File
            </Button>
          }
          filename={getEventName("Investments")}
          status={"processing"}
        />
        <DownloadBPI
          data={bpiUITF.length !== 0 && bpiUITF}
          button={
            <Button
              variant="contained"
              color="primary"
              disabled={bpiUITF.length === 0}
               onClick={updatehasBPIUITF}
              style={{ color: "white", textTransform: "capitalize" }}
              fullWidth
            >
              Export New BPI Investors
            </Button>
          }
          filename={getEventName("Extract BPI UITF Fund")}
          status={"approved"}
        />
        <DownloadATRAM
          data={atramUITF.length !== 0 && atramUITF}
          button={
            <Button
              variant="contained"
              color="primary"
              disabled={atramUITF.length === 0}
               onClick={updatehasATRAMUITF}
              style={{ color: "white", textTransform: "capitalize" }}
              fullWidth
            >
              Export New ATRAM UITF Investors
            </Button>
          }
          filename={getEventName("Extract ATRAM UITF Fund")}
          status={"approved"}
        />
        </>
      ) : (
        <Download
          data={processingRedemptionTransactions}
          button={
            <Button
              variant="contained"
              color="primary"
              style={{ color: "white", textTransform: "capitalize" }}
              fullWidth
            >
              Generate Processing Redemption Excel File
            </Button>
          }
          filename={getEventName("Redemption")}
          status={"processingredemption"}
        />
      )}
    </div>
  );
};
